/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_ImageWithVariants } from './Luci_Shopping_Api_Models_ImageWithVariants';
import type { Luci_Shopping_Api_Models_TagModel } from './Luci_Shopping_Api_Models_TagModel';
export type Luci_Shopping_Api_Models_OrderItem = {
  /**
   * The product id or bundle id.
   */
  id?: number;
  /**
   * The line item id or line item bundle id. Represented as Product:xxx || Bundle:xxx
   */
  lineItemRefKey?: string;
  /**
   * The type of the order item. Product or Bundle.
   */
  type?: Luci_Shopping_Api_Models_OrderItem.type;
  name?: string;
  sku?: string;
  description?: string;
  tags?: Array<Luci_Shopping_Api_Models_TagModel>;
  image?: Luci_Shopping_Api_Models_ImageWithVariants;
  quantity?: number;
  isFree?: boolean;
  isReward?: boolean;
  itemNumberRetailerAssigned?: string;
  returnedLineItem?: number;
  quantityReturned?: number;
  totalTaxAmountReturned?: number;
  claimCode?: number;
  /**
   * The price the product was sold at or the price of the bundle.
   */
  salePrice?: number;
  taxAmount?: number;
  canBeCustomerReward?: boolean;
  rewardPointValue?: number;
  storeCustomerRewardPointsAccrued?: number;
  created?: string;
  children?: Array<Luci_Shopping_Api_Models_OrderItem>;
};
export namespace Luci_Shopping_Api_Models_OrderItem {
  /**
   * The type of the order item. Product or Bundle.
   */
  export enum type {
    PRODUCT = 'Product',
    BUNDLE = 'Bundle',
  }
}

